import Tooltip from "@mui/material/Tooltip";

import type { TalentListItem } from "components/Screens/Marketplace/Customer/types";
// The white tip of the Hidden pill (prototype .tip): heading in bold, then the line
import "components/Screens/Marketplace/Customer/common/Withheld/Withheld.scss";

/**
 * A shortlisted talent who can't be met right now: left the talent network since (e.g. ASSIGNED), or blacklisted,
 * dormant or not available (marketplace sends `available: false`).
 */
export const isUnavailable = (talent: Pick<TalentListItem, "available">) => talent.available === false;

/** Next to the name on a shortlist card; hovering explains they are paused (product 2026-10-24). */
function UnavailablePill() {
  return (
    <Tooltip
      title={
        <>
          <b>Not available right now</b>
          They have been paused on your shortlist. If they become available again, you will see them here.
        </>
      }
      placement="top"
      enterTouchDelay={0}
      leaveTouchDelay={4000}
      slotProps={{ tooltip: { className: "hidden-chip-tip" } }}
    >
      <span className="sl-unavailable" tabIndex={0}>
        <i aria-hidden />
        Unavailable
      </span>
    </Tooltip>
  );
}

export default UnavailablePill;
